import styled from "styled-components";

export const MainContainer = styled.div`
    overflow: auto;
`

export const ContentContainer = styled.div`
    display: flex; 
    flex-direction: row;
    padding: 1%;
`

export const RightButtonContainer = styled.div<{isTablet?: boolean}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    width: ${(props) => props.isTablet ? "100%" : "auto"};

    @media screen and (min-width: 900px) and (max-width: 1225px) {
        width: auto;
    }

    @media screen and (max-width: 620px) {
        margin-top: 20px;
        width: 100%;
        justify-content: flex-start;
    }
`

export const Text = styled.p``

export const GeneralContainer = styled.div<{ width?: string }>`
    width:${props=> props.width ? `${props.width}`:'100%'}

`